import { ReactNode } from "react";
import { cn } from "@/lib/utils";

type GlassPanelProps = {
  children: ReactNode;
  className?: string;
  variant?: "glass" | "solid" | "transparent";
};

const variantClasses: Record<NonNullable<GlassPanelProps["variant"]>, string> = {
  glass: "bg-white/5 border-white/10 hover:bg-white/10 hover:border-white/20 backdrop-blur-md",
  solid: "bg-black border-border shadow-lg hover:bg-black/90",
  transparent: "bg-transparent border-transparent backdrop-blur-md",
};

export function GlassPanel({
  children,
  className,
  variant = "glass",
}: GlassPanelProps) {
  return (
    <div
      className={cn(
        "group relative rounded-2xl border transition-all duration-300 ease-out",
        variantClasses[variant],
        className
      )}
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent" />
      {children}
    </div>
  );
}